import { BitcoinTxHash, } from "@keep-network/tbtc-v2.ts";
import HttpApi from "./HttpApi";
/**
 * Represents a class for integration with tBTC API.
 */
export default class TbtcApi extends HttpApi {
    /**
     * Register deposit data in the tBTC API.
     * @param revealData Deposit data.
     * @returns True if the reveal was successfully saved to the database, false
     * otherwise.
     */
    async saveReveal(revealData) {
        const response = await this.postRequest("reveals", revealData).catch((error) => {
            throw new Error(`Failed to save reveal: ${error}`);
        });
        const { success } = (await response.json());
        return success;
    }
    /**
     * Initiate a bitcoin deposit in the tBTC API.
     * @param depositData Data of the deposit.
     * @returns Details of the initiated deposit.
     */
    async createDeposit(depositData) {
        const response = await this.postRequest("deposits", depositData).catch((error) => {
            throw new Error(`Failed to create deposit: ${error}`);
        });
        const responseData = (await response.json());
        return {
            depositId: responseData.depositId,
            depositStatus: responseData.newDepositStatus,
            fundingOutpoint: {
                transactionHash: BitcoinTxHash.from(responseData.transactionHash),
                outputIndex: responseData.outputIndex,
            },
        };
    }
    /**
     * @param depositOwner Depositor as EVM-chain identifier.
     * @returns All owner deposits, including queued deposits.
     */
    async getDepositsByOwner(depositOwner) {
        const response = await this.getRequest(`deposits/${depositOwner.identifierHex}`).catch((error) => {
            throw new Error(`Failed to fetch deposits: ${error}`);
        });
        const responseData = (await response.json());
        return responseData;
    }
}
// TODO: This type is copied from tbtc-api, we should consider exporting it from there.
/**
 * Represents the status of a deposit.
 */
export var DepositStatus;
(function (DepositStatus) {
    DepositStatus["Queued"] = "QUEUED";
    DepositStatus["Initialized"] = "INITIALIZED";
    DepositStatus["Finalized"] = "FINALIZED";
    DepositStatus["Cancelled"] = "CANCELLED";
    DepositStatus["Migrated"] = "MIGRATED";
})(DepositStatus || (DepositStatus = {}));
//# sourceMappingURL=TbtcApi.js.map